export default "__VITE_ASSET__4e0e1b05__"